import { Directive, Input, OnInit } from '@angular/core';
import { logPageView } from '@office-start/telemetry-service';

import { DeviceDetector, PlatformType } from '../services/device-detector.service';
import { InstrumentationParam, InstrumentationParams, InstrumentationService, KnownInstrumentationEvents } from './instrumentation.service';

@Directive({
    selector: '[ohpInstrumentPageView]'
})
export class InstrumentPageViewDirective implements OnInit {

    @Input('ohpInstrumentPageView') public pageName: KnownInstrumentationEvents;

    constructor(
        private readonly deviceDetector: DeviceDetector,
        private readonly instrumentationService: InstrumentationService
    ) {
    }

    public ngOnInit() {
        const params: InstrumentationParams = {};
        params[InstrumentationParam.DevicePlatform] = PlatformType[this.deviceDetector.getDeviceInfo().platform.platformType];
        this.instrumentationService.logGenericEvent(this.pageName, params, [this.pageName]);

        let isIntentionalFlag = true;
        // Applicable only to PWA where app is prelaunched but user hasn't interacted with it
        if (window.prelaunchMode) {
            isIntentionalFlag = false;
        }
        logPageView({ isIntentional: isIntentionalFlag, eventName: this.pageName });

    }

}
